<template>
    <div :class="['review-card', col]">
        <div class="review-card__inner">
            <div class="flex between">
                <div class="review-card__col sm-12 review-card__col-left">
                    <div class="review-card__col-inner">
                        <div class="review-card__author">
                            <div class="review-card__author-avatar">
                                <img :src="photo" :alt="author">
                            </div>
                            <div class="review-card__author-name" v-if="author">{{ author }}</div>
                            <div class="review-card__author-desc" v-if="author_desc">{{ author_desc }}</div>
                        </div>
                    </div>
                </div>
                <div class="review-card__col sm-12 review-card__col-rigth">
                    <div class="review-card__col-inner">
                        <div class="review-card__text" v-html="text"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ReviewCard',
    inheritAttrs: false,
    props: {
        author: {
            type: String,
            default: '',
        },
        author_desc: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        photo: {
            type: String,
            default: '',
        },
        company_logo: {
            type: String,
            default: '',
        },
        col: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .review-card {
        &__inner {
            background: #fff;
            padding: 100px 88px 75px 88px;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: var(--br-1);
            overflow: hidden;
            height: 100%;

            @include tablet {
                padding: 38px 32px;
            }
            @include mobile {
                padding: 24px;
                > .flex {
                    flex-wrap: wrap;
                }
            }
        }
        &__author {
            &-avatar {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                overflow: hidden;
                @include mobile {
                    width: 50px;
                    height: 50px;
                }

                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }
            }
            &-name {
                margin-top: 24px;
                font-size: 18px;
                line-height: 28px;
                font-family: var(--font-secondary);
                font-weight: 500;
                color: var(--c-gray-120);
                @include mobile {
                    margin-top: 10px;
                }
            }
            &-desc {
                margin-top: 3px;
                font-size: 14px;
                line-height: 20px;
                color: var(--c-secondary-200);
            }
        }
        &__text {
            padding-left: 30px;
            max-width: 850px;
            font-size: 22px;
            line-height: 32px;
            font-family: var(--font-secondary);
            font-weight: 500;

            @include tablet {
                font-size: 14px;
                line-height: 20px;
                font-weight: 400;
                max-width: 420px;
                padding-right: 5%;
            }
            @include mobile {
                max-width: initial;
                padding-right: 0;
                padding-left: 0;
                margin-top: 24px;
            }

            p {
                margin-bottom: 30px;
                @include tablet {
                    margin-bottom: 24px;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
